import React from 'react';
import {colors} from '../theme/tokens/colors';

export interface CheckCircleIconProps {
  color?: keyof typeof colors;
  size?: number;
  style?: React.CSSProperties;
}

export const CheckCircleIcon = React.memo<CheckCircleIconProps>(
  ({color = 'textLow', size = 24, style}) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3C8.373 3 3 8.373 3 15C3 21.627 8.373 27 15 27C21.627 27 27 21.627 27 15C27 12.82062 26.41 10.78314 25.39453 9.02148L14.14648 20.26757C13.95948 20.45457 13.70545 20.56054 13.43945 20.56054C13.17445 20.56054 12.91942 20.45557 12.73242 20.26757L8.27929 15.81445C7.88829 15.42345 7.88829 14.79139 8.27929 14.40039C8.67029 14.00939 9.30235 14.00939 9.69335 14.40039L13.43944 18.14648L24.24022 7.3457C22.03922 4.6907 18.71799 3 15 3ZM24.24023 7.3457C24.67188 7.86628 25.05374 8.43005 25.39453 9.01953L27.70703 6.70703C28.09803 6.31503 28.09803 5.68397 27.70703 5.29297C27.31603 4.90197 26.68397 4.90197 26.29297 5.29297L24.24023 7.3457Z"
        fill={colors[color] || color}
      />
    </svg>
  ),
);
